
import { mapGetters } from 'vuex';

export default {
  name: 'CompanyDescriptionWidget',

  computed: {
    ...mapGetters('profile', ['profile']),

    currentDisplayLanguage() {
      return this.$i18n.locale;
    },

    companyDescription() {
      const translation =
        this.profile?.translations?.[this.currentDisplayLanguage];

      return translation?.description ?? this.profile?.description ?? '';
    },
  },
};
